import React, { useEffect } from 'react';
import t from 'prop-types';
import { connect } from 'react-redux';
import { withPermissions } from '../../routing';
import { mergeRequestStatuses } from '../../utils';
import Messages from '../components/messages';
import { loadMessage, needAssistanceLoadResource } from '../redux/operations';
import { Alert, AsyncLoader, Loader } from 'fiducius-ui';

const NeedAssistance = ({
  permissions,
  loadMessage,
  request,
  messageType,
  showModal,
  modalMessage,
  data = {},
}) => {
  useEffect(() => {
    loadMessage(messageType);
  }, []);

  const messageObject = getMessageObject();
  const messageId = messageObject && messageObject.id;
  const contentType = messageObject && messageObject.contentType;
  const avatarLink = messageObject && messageObject.avatarLink;
  const messageContent = messageObject && messageObject.messageContent;
  const showAvatar = avatarLink && avatarLink.length > 0;
  const showMessage = messageContent && messageContent.length > 0;
  const displayContent = showAvatar || showMessage;
  const showAlert =
    contentType === 'MESSAGE' &&
    ((messageType && messageType.indexOf('_Alert') > 0) || messageId.indexOf('Alert') > 0);

  if (displayContent && modalMessage) {
    showModal();
  }

  return (
    <>
      {request.notStarted || request.isLoading ? (
        <>
          <Loader variant="atom" size={3} />
          <br />
        </>
      ) : (
        <></>
      )}
      {displayContent && (
        <div>
          <AsyncLoader request={request} loading={<>loading!</>}>
            {showAlert && (
              <Alert brand="warning">
                <Messages
                  noPadding={true}
                  messageType={messageType}
                  contentType={contentType}
                  avatarLink={avatarLink}
                  messageContent={messageContent}
                  showAvatar={showAvatar}
                  showMessage={showMessage}
                />
              </Alert>
            )}

            {!showAlert && (
              <Messages
                noPadding={true}
                messageType={messageType}
                contentType={contentType}
                avatarLink={avatarLink}
                messageContent={messageContent}
                showAvatar={showAvatar}
                showMessage={showMessage}
              />
            )}
          </AsyncLoader>
        </div>
      )}
    </>
  );

  // function getMessageObject() {
  //   const dataObject = data && data.length > 0 && data.find((a) => a.id === messageType);
  //   const messageObject =
  //     dataObject && Object.keys(dataObject).length > 0
  //       ? dataObject.messages && dataObject.messages.find((a) => a.id === messageType)
  //       : undefined;
  //   return messageObject;
  // }

  function getMessageObject() {
    const dataObject = data && data.length > 0 && data.find((a) => a.id === messageType);
    const messageObject = dataObject ? dataObject : undefined;
    return messageObject;
  }
};

const mapStateToProps = (state) => ({
  request: state.needAssistance.requests.updateResource,
  // request: mergeRequestStatuses([
  //   // state.todos.requests.updateResource,
  //   // state.todos.requests.loadCollection,
  //   state.needAssistance.requests.loadCollection,
  //   state.needAssistance.requests.updateResource,
  // ]),
  data: Object.values(state.needAssistance.cache),
});

NeedAssistance.propTypes = {
  load: t.func.isRequired,
  loadMessage: t.func.isRequired,
  messageType: t.string.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  load: async (id) => {
    await dispatch(needAssistanceLoadResource(id));
  },
  loadMessage: async (id) => {
    await dispatch(loadMessage(id));
  },
});

//export default connect(mapStateToProps, mapDispatchToProps)(NeedAssistance);
export default connect(mapStateToProps, mapDispatchToProps)(withPermissions(NeedAssistance));
